export function FormatedDate(date: string) {
  const dateSplit = date.split(' ')[0];
  const newDate = dateSplit.split('/');
  const finalDate = `${newDate[2]}/${newDate[1]}/${newDate[0]}`;

  return finalDate;
}

// Mapeia o tipo para chave de tradução do Glota
export function FormatedTypeChangeKey(type: string): string {
  switch(type){
    case 'ativado':
      return "spa.tools.logsActivated";
    case 'desativado':
      return 'spa.tools.logsDeactivated';
    case 'excluido':
      return 'spa.tools.logsDeleted';
    case 'desconectado':
      return 'spa.tools.logsDisconnected';
    case 'conectado':
      return 'spa.tools.logsConnected';
    default:
      return type;
  }
}

export function FormatedTypeChange(type: string) {
  switch(type){
    case 'ativado':
      return "ativado";
    case 'desativado':
      return 'desativado';
    case 'excluido':
      return 'excluído';
    case 'desconectado':
      return 'desconectado';
    case 'conectado':
      return 'conectado';
  }
}
